import {clearLocalStorage, getDataLocalStorage, setDataLocalStorage} from "../react/utils/localStorage";


const OPEN_MAIN_MENU_ITEM_STORAGE_KEY = 'open_main_menu_item';

class Header {
  constructor(elementClass) {
    this.headerScroll = 'js-header-scroll';
    this.headerActive = 'js-header-open';
    this.headerClose = 'js-header-close';
    this.headerNavClose = 'js-header-nav-open';
    this.noScroll = 'no-scroll';

    this.header = document.querySelector(`.${elementClass}`);
    this.menu = document.querySelector(`.${elementClass}__menu`);
    this.navigation = this.header?.querySelectorAll('.menu-item-has-children');
    this.burger = document.querySelector(`.${elementClass}__burger`);
    this.control = document.querySelector(`.${elementClass}__control`);
    this.logout = document.querySelector(`.${elementClass}__control-logout`);
    this.body = document.body;
    this.adaptive = true || window.innerWidth <= 1024;
  }

  init() {
    const handlerRemoveClass = () => {
      if (this.adaptive && this.header?.classList.contains(this.headerActive)) {
        this.header.classList.add(this.headerClose);
        this.header.classList.remove(this.headerActive);
        this.body.classList.remove(this.noScroll);
      }
    };
    const classesArray = [this.headerActive, this.headerClose, this.headerNavClose, this.noScroll];

    window.addEventListener('resize', () => {
      this.resizeHandler(classesArray);
    });

    document.addEventListener('scroll', () => {
      this.headerScrollHandler();
    });

    document.addEventListener('click', (event) => {
      if (!event.isTrusted) return;
      this.handlerClickOutside(event, this.header, handlerRemoveClass);
    });

    this.burger?.addEventListener('click', (e) => {
      if (!e.isTrusted) return;
      if (this.adaptive) {
        this.headerBurgerHandler();
      }
    });

    const openItemID = getDataLocalStorage(OPEN_MAIN_MENU_ITEM_STORAGE_KEY);
    const toggleSubMenu = item => {
      item.classList.toggle(this.headerNavClose);
      const subMenu = item.querySelector('.sub-menu');
      if (item.classList.contains(this.headerNavClose)) {
        const mh = +subMenu.scrollHeight + 14;
        subMenu.style.maxHeight = `${mh}px`;
      } else {
        subMenu.style.maxHeight = null;
      }
    }

    this.navigation?.forEach((item) => {
      if (this.adaptive && openItemID === item.id) {
        this.headerBurgerHandler();
        toggleSubMenu(item);
        clearLocalStorage([OPEN_MAIN_MENU_ITEM_STORAGE_KEY]);
      }
      item.addEventListener('click', (event) => {
        if (!event.isTrusted) {
          event.preventDefault();
          return;
        }
        if (event.target.parentElement === item) {
          const { href } = event.target;
          if (this.adaptive) {
            if (window.location.href === href) {
              event.preventDefault();
              toggleSubMenu(item);
            } else {
              setDataLocalStorage({
                [OPEN_MAIN_MENU_ITEM_STORAGE_KEY]: item.id
              });
              window.location.href = href;
            }
          } else {
            window.location.href = href;
          }
        }
      });
    });

    this.menu?.addEventListener('animationend', (e) => {
      if (this.adaptive) {
        if (e.animationName === 'headerMenuClose' || e.animationName === 'headerMenuCloseVertical') {
          this.header.classList.remove(this.headerClose);
        }
      }
    });
  }

  resizeHandler(classesArray) {
    this.adaptive = true || window.innerWidth <= 1024;
    if (!this.adaptive) {
      classesArray.forEach((className) => {
        const elements = document.querySelectorAll(`.${className}`);
        if (elements.length) {
          elements.forEach((item) => {
            item.classList.remove(className);
          });
        }
      });
      this.header?.querySelectorAll('.sub-menu').forEach((subMenu) => {
        subMenu.style.maxHeight = null;
      });
    }
  }
  headerBurgerHandler() {
    this.header.classList.toggle(this.headerActive);
    if (this.header.classList.contains(this.headerActive)) {
      this.body.classList.add(this.noScroll);
    } else {
      this.header.classList.add(this.headerClose);
      this.body.classList.remove(this.noScroll);
    }
  }

  handlerClickOutside(event, element, callback) {
    const withinBoundaries = event.composedPath().includes(element);
    if (!withinBoundaries) {
      callback();
    }
  }

  headerScrollHandler() {
    const headerScrollClass = this.headerScroll;
    const checkHeaderIsActive = () => this.header?.classList.contains(headerScrollClass);
    const checkIsHeaderTopPosition = () => this.body.getBoundingClientRect().top >= 0;
    const setHeaderActive = () => {
      !checkHeaderIsActive() && this.header?.classList.add(headerScrollClass);
    };
    const setHeaderNoActive = () => {
      checkHeaderIsActive() && this.header.classList.remove(headerScrollClass);
    };
    const toggleHeader = (param) => {
      param ? setHeaderActive() : setHeaderNoActive();
    };

    toggleHeader(!checkIsHeaderTopPosition());
  }
}

const header = new Header('header');
header.init();
